import { Limit } from './limit';
/**
 * Created by karthikeyan.k on 27-11-2018.
 */
export class GameLobby {
  game: string;
  gameType: string;
  gameName: string;
  tableType: string;
  featureName: string;
  langCode: string;
  gameLangCode: string;
  isComingSoon: boolean;
  isSecret: boolean = false;
  imageName: string;
  iconName: string;
  overImageName: string;
  underlayImageName: string;
  overlayImageName: string;
  isPrivate: boolean;
  players: string;
  betlimitId: number;
  tableLimits: string;
  decks: string;
  seat: string;
  shuffles: string;
  limits: Array<Limit>;
  minbet: number;
  maxbet: number;
}
